import {
  CtaButtonToggle,
  StyledToggle,
  ToggleContainer,
  ToggleLine,
  ToggleWrapper,
} from './styles/Toggle';

export function Toggle({ isOpen, children, ...props }) {
  const accessibilityProps = {
    'aria-expanded': isOpen || null,
    'aria-label': props['aria-label'],
  };

  return (
    <ToggleContainer>
      {children && <CtaButtonToggle $isOpen={isOpen}>{children}</CtaButtonToggle>}
      <StyledToggle $isOpen={isOpen} type="button" {...accessibilityProps} {...props}>
        <ToggleWrapper $isOpen={isOpen}>
          <ToggleLine $isOpen={isOpen} />
          <ToggleLine $isOpen={isOpen} />
          <ToggleLine $isOpen={isOpen} />
        </ToggleWrapper>
      </StyledToggle>
    </ToggleContainer>
  );
}

export default Toggle;
